import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { FabProcessStep, ListItem, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './fab-process-step.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class FabProcessStepComponent extends RepositoryModal<FabProcessStep> {
    categoryOptions: ListItem<string>[] = [
        new ListItem('Drafting', 'Drafting'),
        new ListItem('Material', 'Material'),
        new ListItem('Fabrication', 'Fabrication'),
        new ListItem('Coating', 'Coating'),
        new ListItem('Shipping', 'Shipping'),
        new ListItem('Billing', 'Billing'),
    ]

    protected onInitialized(): void {
        if (this.isAdding || this.isDuplicating) {
            if (!this.target.id) this.target.id = crypto.randomUUID()
            if (this.target.active === undefined) this.target.active = true
            if (!this.target.colorHex) this.target.colorHex = '#CCCCCC'
            if (this.target.leadTimeDays === undefined) this.target.leadTimeDays = 0
            if (this.target.progressWeight === undefined) this.target.progressWeight = 0
            if (this.target.sortOrder === undefined) this.target.sortOrder = 0
            if (!this.target.category) this.target.category = 'Fabrication'
        }
        if (!this.target.category) this.target.category = 'Fabrication'
    }
}
